import React from 'react';
import { Search, User, Mail, Phone, Calendar, Building2 } from 'lucide-react';



interface AssetWhoisProps {
  data: any;
}
function parseDate(dateString: string) {
  // Check if the string matches the format "YYYY-MM-DDTHH"
  if (/^\d{4}-\d{2}-\d{2}T\d{2}$/.test(dateString)) {
    // Append minutes and seconds.
    // You can also append 'Z' at the end if the time is in UTC (e.g., ':00:00Z')
    dateString += ':00:00';
  }
  return new Date(dateString);
}
export const AssetWhois: React.FC<AssetWhoisProps> = ({ data }) => {
  return (
    <div className="bg-[#0F1629] rounded-xl p-6 border border-gray-800/50">
      <div className="flex items-center space-x-2 mb-4">
        <Search className="h-5 w-5 text-blue-500" />
        <h2 className="text-lg font-semibold text-white">WHOIS Record</h2>
      </div>

      <div className="space-y-4">
        <div>
          <div className="text-sm text-gray-400">Registrar</div>
          <div className="text-sm font-medium text-white mt-1">{data.Registrar || 'Unknown'}</div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-sm text-gray-400">Registered On</div>
            <div className="flex items-center space-x-2 mt-1">
              <Calendar className="h-4 w-4 text-gray-500" />
                      <span className="text-sm text-white">
          {data.Creation_Date 
            ? parseDate(data.Creation_Date).toLocaleDateString() 
            : 'Unknown'}
        </span>
            </div>
          </div>

          <div>
            <div className="text-sm text-gray-400">Expires On</div>
            <div className="flex items-center space-x-2 mt-1">
              <Calendar className="h-4 w-4 text-gray-500" />
              <span className="text-sm text-white">
  {data.Expiration_Date	 
    ? parseDate(data.Expiration_Date	).toLocaleDateString() 
    : 'Unknown'}
</span>
            </div>
          </div>
        </div>

        <div>
          <div className="text-sm text-gray-400">Organization</div>
          <div className="flex items-center space-x-2 mt-1">
            <Building2 className="h-4 w-4 text-gray-500" />
            <span className="text-sm text-white">{data.Tech_Organization	 || 'Unknown'}</span>
          </div>
        </div>

        <div className="pt-4 border-t border-gray-800">
          <div className="text-sm text-gray-400 mb-3">Contact Information</div>
          
          <div className="space-y-3">
            <div className="flex items-center space-x-2">
              <User className="h-4 w-4 text-gray-500" />
              <span className="text-sm text-white">{data.Tech_Name|| 'Unknown'}</span>
            </div>

            <div className="flex items-center space-x-2">
              <Mail className="h-4 w-4 text-gray-500" />
              <span className="text-sm text-white">{data.Tech_Email		 || 'Unknown'}</span>
            </div>

            <div className="flex items-center space-x-2">
              <Phone className="h-4 w-4 text-gray-500" />
              <span className="text-sm text-white">{data.Tech_Phone || 'Unknown'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};